/**
 * RouteLayer — renders the active route on the map.
 * Route drawing is controlled via useRoute hook called from DayPlanner.
 */
export function RouteLayer() {
  // Route rendering is handled imperatively inside useRoute.calculateRoute
  // This component is a placeholder for future declarative route state rendering.
  return null;
}
